var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "main",
      staticClass: "camstudy-p2p row v-grid1",
      class: _vm.isMobile ? "p2p-video-main-mobile" : "p2p-video-main",
      staticStyle: { width: "100%", height: "100%" },
      attrs: { "data-grm-comp": "RoomCallCamstudyP2P" },
    },
    [
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [!_vm.isAttend(_vm.me.userId) ? _c("CamStudyAttendance") : _vm._e()],
        1
      ),
      _c("CallStopWatch"),
      _c(
        "div",
        { ref: "subVideosWrapper", staticClass: "mobile-video-scroll" },
        [
          _c(
            "div",
            {
              ref: "subVideos",
              staticClass: "sub-videos-mobile",
              class: _vm.roomUserCountStyle,
              attrs: { "data-pip-mode": _vm.pip },
            },
            [
              _vm.mainVideoUser.userId
                ? _c("RoomCallCamStudyP2PVideo", {
                    staticClass: "main-video",
                    attrs: { user: _vm.mainVideoUser },
                    on: { mounted: _vm.addSubVideosObserve },
                  })
                : _vm._e(),
              _vm._l(_vm.pinSubVideoUserList, function (user, idx) {
                return _c("RoomCallCamStudyP2PVideo", {
                  key: user.userId + "@" + user.screenShare,
                  staticClass: "sub-video",
                  attrs: {
                    user: user,
                    idx: idx,
                    defaultVideoObjectFit: "contain",
                    pin: _vm.isPin(user.userId),
                    isOpenUserControl: _vm.isOpenUserControl(user.userId),
                    draggable: true,
                  },
                  on: {
                    click: _vm.onSelectUserToggle,
                    onPinMode: _vm.onPinMode,
                    mounted: _vm.addSubVideosObserve,
                    destroyed: _vm.removeSubVideosObserve,
                  },
                  nativeOn: {
                    dragstart: function ($event) {
                      return _vm.onVideoDragStart($event, user)
                    },
                    dragenter: function ($event) {
                      return _vm.onVideoDragEnter($event, user)
                    },
                    dragleave: function ($event) {
                      $event.preventDefault()
                      return _vm.onVideoDragLeave($event, user)
                    },
                    drop: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.onVideoDrop($event, user)
                    },
                    dragover: function ($event) {
                      $event.preventDefault()
                    },
                  },
                })
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }